import type { TFunction } from 'i18next';
import { BookingApi, ResponseError } from '@linktivity/ars-neo';
import { visitorCredentials } from '../../../auth/tokens';
import { createArsConfig } from '../../../services/ars';

/** Sessions are the visitor's own, so they go out with the visitor's token. */
export const bookingApi = new BookingApi(createArsConfig(visitorCredentials));

/**
 * The message to show for a failed request, in the wording the SPA's API
 * client used: the translated ARS error when there is one, else the API's own
 * description, else — for a client error — its error id, and a generic server
 * error for everything else.
 */
export async function describeApiError(
  error: unknown,
  t: TFunction,
  exists: (key: string) => boolean
): Promise<string> {
  if (error instanceof ResponseError) {
    // The SDK's raw body: snake_case, unlike the typed responses.
    const data = await error.response
      .clone()
      .json()
      .catch(() => null);
    const errorId: string | undefined = data?.error_id;
    const key = `share.apiErrors.ARSError.${errorId}`;
    if (errorId && exists(key)) return t(key);
    if (data?.error_description) return String(data.error_description);
    if (errorId && error.response.status < 500) return errorId;
  }
  return t('share.apiErrors.serverError');
}
